(function ($) {
    let initCount = 0;


    jQuery.fn.customSelect2 = function () {

        let init = function () {

            if (!$(this).is('.disabled')) {
                if (!$(this).parents('.custom-select-wrap').is('div')) {
                    $(this).wrap("<div class='custom-select-wrap' tabindex='0'></div>");
                }

                let wrap = $(this).parents('.custom-select-wrap');
                $(wrap).find('.fake-select').remove();
                $(wrap).find('.options-list-wrap').remove();

                let option = $(this).find('option:selected');
                let selectVal = $(option).text();

                if (typeof $(option).attr('data-icon') !== "undefined") {
                    selectVal = '<img src="' + $(option).attr('data-icon') + '" alt="icon">' + selectVal;
                }

                let optionsStr = '';
                $(this).find('option').each(function () {
                    let value = $(this).html();
                    optionsStr += '<li data-letter="' + value.substr(0, 1).toLowerCase() + '" value="' + $(this).attr('value') + '">';
                    if (typeof $(this).attr('data-icon') !== "undefined") {
                        optionsStr += '<img src="' + $(this).attr('data-icon') + '" alt="icon">';
                    }
                    optionsStr += value;
                    optionsStr += '</li>';
                });
                if (typeof $(option).attr('data-icon') == "undefined") {
                    $(this).after("<div class='fake-select'><div class='value'></div><div class='control-label'>" + $(this).find('option:first-child').html() + "</div><span class='ico-arrow'></span></div>");
                }
                else {
                    $(this).closest(".custom-select-wrap").addClass("choosen")
                    $(this).after("<div class='fake-select'><div class='value visible'></div><div class='control-label'>" + $(this).find('option:first-child').html() + "</div><span class='ico-arrow'></span></div>");
                }

                if ($(this).attr('data-input-search') === 'true' && customSelectLang) {
                    $(this).after("<div class='options-list-wrap'>" +
                        "<input class='search-input' placeholder='" + customSelectLang.searchLabel + "'>" +
                        "<i class='far fa-times-circle'></i>" +
                        "<span class='magnifier'></span>" +
                        "<ul class='options-list'>" + optionsStr + "</ul></div>"
                    );
                } else {
                    $(this).after("<div class='options-list-wrap'><ul class='options-list'>" + optionsStr + "</ul></div>");
                }

                $(this).hide();
                $(this).parents('.custom-select-wrap').find('.fake-select .value').html(selectVal);
                $(this).parents('.custom-select-wrap').find('.options-list li[value="' + $(this).val() + '"]').addClass('active');
            }
        };

        initCount += 1;

        if (initCount === 1) {
            function clearSearch() {
                $('.custom-select-wrap .search-input').val('');
                $('.custom-select-wrap .fa-times-circle').hide();
                $('.custom-select-wrap .options-list li').show();
            }

            $(document).on('click', '.fake-select', function () {
                if (!$(this).parents('.custom-select-wrap').is('.active')) {
                    $('.custom-select-wrap').removeClass('active');

                    let lenghtOptions = $(this).parents('.custom-select-wrap').find('select option').length;

                    if (lenghtOptions > 1) {
                        $(this).parents('.custom-select-wrap').addClass('active');

                        let start = parseInt($($(this).parents('.custom-select-wrap')).find('.options-list').scrollTop());
                        let offsetLi = 0;
                        if ($($(this).parents('.custom-select-wrap')).find('.options-list li').is('.active')) {
                            offsetLi = parseInt($($(this).parents('.custom-select-wrap')).find('.options-list li.active').position().top);
                        }
                        $($(this).parents('.custom-select-wrap')).find('.options-list').scrollTop(start + offsetLi);
                    }

                } else {
                    $('.custom-select-wrap').removeClass('active');
                }
            });

            $(document).on('click', '.custom-select-wrap .options-list li', function () {
                $('.custom-select-wrap').removeClass('active');
                let select = $(this).parents('.custom-select-wrap').find('select');
                $(select).val($(this).attr('value')).change();

                $(select).trigger("customSelect2Change");

                let option = $(select).find('option:selected');
                let selectVal = $(option).text();

                if (typeof $(option).attr('data-icon') !== "undefined") {
                    selectVal = '<img src="' + $(option).attr('data-icon') + '" alt="icon">' + selectVal;
                }
                $(this).parents('.custom-select-wrap').find('.fake-select .value').html(selectVal);
                $(this).parents('.custom-select-wrap').find('.options-list li').removeClass('active');
                clearSearch();
                $(this).addClass('active');

                if ($(this).val()) {
                    $(this).closest(".custom-select-wrap").addClass("choosen")
                    $(this).closest(".custom-select-wrap").find(".fake-select .value").addClass("visible")
                }
                else {
                    $(this).closest(".custom-select-wrap").removeClass("choosen")
                    $(this).closest(".custom-select-wrap").find(".fake-select .value").removeClass("visible")
                }
            });

            $(document).on('focusout', '.custom-select-wrap.active', function () {
                setTimeout(function () {
                    if (!$(':focus').is('.search-input') && !$(':focus').is('.custom-select-wrap.active')) {
                        clearSearch();
                        $('.custom-select-wrap').removeClass('active');
                    }
                }, 1);
            });

            $(document).on('click', '.custom-select-wrap.active .fa-times-circle', function () {
                clearSearch();
            });

            $(document).on('keyup', '.custom-select-wrap.active .search-input', function (event) {
                let lengthStr = parseInt($(this).val().length);
                if (lengthStr > 0) {
                    $('.custom-select-wrap.active .fa-times-circle').show();
                    let currenVal = $(this).val().toLowerCase();
                    $('.custom-select-wrap.active .options-list li').each(function () {
                        if ($(this).text().toLowerCase().trim().indexOf(currenVal) === 0) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    });
                } else {
                    clearSearch();
                }
            });

            $(document).on('keydown', function (event) {
                let activeSelect;

                if ($(':focus').is('.custom-select-wrap')) {
                    if (event.keyCode === 40
                        || event.keyCode === 38
                        || event.keyCode === 37
                        || event.keyCode === 39
                        || event.keyCode === 13
                        || event.keyCode === 32
                        || event.keyCode >= 1040 && event.keyCode <= 1105
                        || event.keyCode >= 49 && event.keyCode <= 222 && event.keyCode !== 220
                    ) {
                        if ($('.custom-select-wrap:focus .fake-select').is('div')) {
                            event.preventDefault();
                            activeSelect = $('.custom-select-wrap:focus .fake-select');
                        }
                        if ($('.custom-select-wrap').is('.active')) {
                            event.preventDefault();
                            activeSelect = $('.custom-select-wrap.active .fake-select');
                        }

                        let custom_select_wrap = $(activeSelect).parents('.custom-select-wrap');

                        if (typeof $(activeSelect) !== "undefined") {
                            let select = $(activeSelect).parents('.custom-select-wrap').find('select');

                            if (event.keyCode === 38 || event.keyCode === 37) { // Up/Left
                                $(select).find('option:selected').prev().prop('selected', true);

                                if ($(select).closest(".js-signup")) {
                                    $(select).closest(".custom-select-wrap").addClass("choosen")
                                    $(select).closest(".custom-select-wrap").find(".fake-select .value").addClass("visible")
                                }

                            }

                            if (event.keyCode === 40 || event.keyCode === 39) { // Right/Down
                                $(select).find('option:selected').next().prop('selected', true);
                                $(select).closest(".custom-select-wrap").addClass("choosen")
                                $(select).closest(".custom-select-wrap").find(".fake-select .value").addClass("visible")
                            }

                            if (event.keyCode === 13) { // Enter
                                $('.custom-select-wrap.active').removeClass('active');
                                $(select).change();
                                $(select).trigger("customSelect2Change");
                            }

                            if (event.keyCode === 32) { // Space
                                $(select).find('option:selected').next().prop('selected', true);
                                if ($(select).closest(".js-signup")) {
                                    $(select).closest(".custom-select-wrap").addClass("choosen")
                                    $(select).closest(".custom-select-wrap").find(".fake-select .value").addClass("visible")
                                }
                            }

                            if (event.keyCode >= 1040 && event.keyCode <= 1105
                                || event.keyCode >= 49 && event.keyCode <= 222 && event.keyCode !== 220
                            ) {
                                let value = $(custom_select_wrap).find('.options-list li[data-letter="' + event.key.toLowerCase() + '"]').attr('value');
                                if (value !== undefined) {
                                    $(select).find('option[value="' + value + '"]').prop('selected', true);
                                    if ($(select).closest(".js-signup")) {
                                        $(select).closest(".custom-select-wrap").addClass("choosen")
                                        $(select).closest(".custom-select-wrap").find(".fake-select .value").addClass("visible")
                                    }
                                }
                            }

                            let option = $(select).find('option:selected');
                            let selectVal = $(option).text();

                            if (typeof $(option).attr('data-icon') !== "undefined") {
                                selectVal = '<img src="' + $(option).attr('data-icon') + '" alt="icon">' + selectVal;
                            }

                            $(custom_select_wrap).find('.fake-select .value').html(selectVal);
                            $(custom_select_wrap).find('.options-list li').removeClass('active');
                            $(custom_select_wrap).find('.options-list li[value="' + $(select).val() + '"]').addClass('active');

                            let start = parseInt($(custom_select_wrap).find('.options-list').scrollTop());
                            let offsetLi = parseInt($(custom_select_wrap).find('.options-list li.active').position().top);
                            $(custom_select_wrap).find('.options-list').scrollTop(start + offsetLi);
                        }
                    }
                }
            });
        }

        return this.each(init);
    };
})(jQuery);